import css from './Header.module.css';
import { FaHome, FaSun, FaMoon } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../context/themeContext';

const Header = () => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const navigateHome = () => {
    navigate('/');
  };

  return (
    <div className={css.header}>
      <div className={css.homeIcon} onClick={navigateHome}>
        <FaHome />
      </div>
      <div className={css.themeToggle} onClick={toggleTheme}>
        {theme === 'light' ? <FaMoon /> : <FaSun />}
      </div>
    </div>
  );
};

export default Header;